import { useCallback, useEffect, useState } from "react";

export function useTabs(
  tabValue: string | null,
  callback?: (v: string | null) => void,
) {
  const [activeTab, setActiveTab] = useState(tabValue);
  const handleChange = useCallback(
    (v: string | null) => {
      setActiveTab(v);
      callback && callback(v);
    },
    [callback],
  );

  useEffect(() => {
    setActiveTab(tabValue);
  }, [tabValue, setActiveTab]);

  return { activeTab, setActiveTab: handleChange };
}
